import React from 'react';
import { AdacHeadline } from '@adac-de/component-library';
import styles from './selected-partner-box.module.scss';
import { List } from '@components/list/list';
import { Richtext } from '@components/richtext/richtext';

export const SelectedPartnerBox: React.FC<{
  selectedPartners: string[];
  selectedPartnersContent: PvWizardSectionOffer['selectedPartnersContent'];
}> = ({ selectedPartners, selectedPartnersContent }) => (
  <div className={styles.selectedPartnerBox}>
    <AdacHeadline tagName="h3" styleAs="h4" className="margin-bottom--xs">
      {selectedPartnersContent.headline}
    </AdacHeadline>
    <Richtext
      document={selectedPartnersContent.text}
      textType="normal"
      className="margin-bottom--s"
    />
    <List listItems={selectedPartners} listItemClassName={styles.listItem} textType="normal" />
  </div>
);
